import React from 'react';

import { faSignOut } from '@fortawesome/pro-regular-svg-icons/faSignOut';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Typography } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';

import { ConfigService } from '../../common/config.service';
import useAnalytics from '../../useAnalytics';

export const UserPanel = (props: any) => {
  const { oktaAuth } = useOktaAuth();
  const { logEvent } = useAnalytics();
  return (
    <Box display="flex" alignItems="baseline" flexDirection="row">
      <Box>
        <Typography color="textSecondary">{props.name}</Typography>
      </Box>
      <Box marginLeft="2px">
        <IconButton
          size="small"
          onClick={evt => {
            evt.preventDefault();
            logEvent('Application sign out', {
              flush: true,
            });
            oktaAuth.signOut({
              postLogoutRedirectUri: ConfigService.getInstance().getLogoutUrl(),
            });
          }}
        >
          <FontAwesomeIcon icon={faSignOut} />
        </IconButton>
      </Box>
    </Box>
  );
};
